{
  "jira-pandora.common.footer.address.no-translate": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "jira-pandora.common.footer.copyright.no-translate": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "jira-pandora.common.project-access-email.banner.alt": [
    {
      "type": 0,
      "value": "Jira banner image"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.body.content": [
    {
      "type": 0,
      "value": "You can now access "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "projectName"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.body.redacted.content": [
    {
      "children": [
        {
          "type": 0,
          "value": "You can now access your Jira project"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.button.redacted.text": [
    {
      "type": 0,
      "value": "View project"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.button.text": [
    {
      "type": 0,
      "value": "View project"
    }
  ],
  "jira-pandora.jira-project-access-granted.message-template.email.redacted.subject": [
    {
      "type": 0,
      "value": "You've been granted access to your project"
    }
  ],
  "jira-pandora.jira-project-access-granted.message-template.email.subject": [
    {
      "type": 0,
      "value": "You've been granted access to "
    },
    {
      "type": 1,
      "value": "projectName"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.body.content": [
    {
      "type": 0,
      "value": "Users have requested to join "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "projectName"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " project"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.body.redacted.content": [
    {
      "children": [
        {
          "type": 0,
          "value": "Users have requested to join your Jira project"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.button.redacted.text": [
    {
      "type": 0,
      "value": "View access requests"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.button.text": [
    {
      "type": 0,
      "value": "View access requests"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.message-template.email.redacted.subject": [
    {
      "type": 0,
      "value": "Access request for your project"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.message-template.email.subject": [
    {
      "type": 0,
      "value": "Access request for "
    },
    {
      "type": 1,
      "value": "projectName"
    }
  ]
}